import { fetchAll } from '@/lib/api/paged'

/** `{ field: { from, to } }` — the recorder writes only tracked columns here. */
export type ActivityChanges = Record<string, { from: string | number | null; to: string | number | null }>

export interface ActivityEntry {
  id: string
  verb: string
  changes: ActivityChanges | null
  occurredAt: string
  /** The class basename — WorkItem, Comment, Attachment, Project. */
  subjectType: string
  subjectId: string
  actor?: { id: string; name: string; color: string | null } | null
}

/**
 * The stream, narrowed either to one project or to one record.
 *
 * Activity rows carry no visibility column of their own, which is why the
 * recorder keeps comment bodies and filenames out of them — what is in a
 * comment lives on the comment, where the audience is decided.
 */
export async function fetchActivity(
  filters: { project?: string | undefined; subjectId?: string | undefined } = {},
): Promise<ActivityEntry[]> {
  return fetchAll<ActivityEntry>('/activities', filters as Record<string, string>)
}
